import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountStatusPeriod, TerminationReason } from 'models';

const endpointPrefix = 'api/accountLifecycle';

export interface AdminDeactivationRequest {
	terminationReason: TerminationReason;
	terminationNotes: string;
}

@Injectable({ providedIn: 'root' })
export class AccountStatusService {
	constructor(private http: HttpClient) { }

	get(clientId: string): Observable<AccountStatusPeriod[]> {
	    return this.http.get<AccountStatusPeriod[]>(`${endpointPrefix}/history/${clientId}`);
	}

	deactivate(clientId: string, model: AdminDeactivationRequest): Observable<unknown> {
		return this.http.post(`${endpointPrefix}/deactivate/${clientId}`, model);
	}

	reactivate(clientId: string): Observable<unknown> {
		return this.http.post(`${endpointPrefix}/reactivate/${clientId}`, {});
	}
}
